<div *ngIf="initialized">

    <div class="grid">

        <div class="col-2">
            <!--            <form (ngSubmit)="onSearch()">-->
            <!--                <div class="flex flex-column gap-3">-->

            <!--                    <div class="flex flex-column gap-2" *ngIf="showSearchId">-->
            <!--                        <label for="searchId" class="text-500 text-sm">ID</label>-->
            <!--                        <input id="searchId" name="searchId" type="number" pInputText [(ngModel)]="searchId"/>-->
            <!--                    </div>-->

            <!--                    <div class="flex flex-column gap-2" *ngIf="showSearchName">-->
            <!--                        <label for="searchName" class="text-500 text-sm">Name</label>-->
            <!--                        <input id="searchName" name="searchName" type="text" pInputText [(ngModel)]="searchName"/>-->
            <!--                    </div>-->

            <!--                    <div class="flex flex-column gap-2" *ngIf="showSearchAlias">-->
            <!--                        <label for="searchAlias" class="text-500 text-sm">Alias</label>-->
            <!--                        <input id="searchAlias" name="searchAlias" type="text" pInputText [(ngModel)]="searchAlias"/>-->
            <!--                    </div>-->

            <!--                    <div class="flex justify-content-end">-->
            <!--                        <p-button label="Search" type="submit"></p-button>-->
            <!--                    </div>-->

            <!--                </div>-->
            <!--            </form>-->

            <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
                <div class="flex flex-column gap-3">
                    <div class="flex flex-column gap-2" *ngIf="showSearchId">
                        <label for="searchId" class="text-500 text-sm">ID</label>
                        <input id="searchId" name="searchId" type="number" pInputText formControlName="searchId">
                    </div>

                    <div class="flex flex-column gap-2" *ngIf="showSearchName">
                        <label for="searchName" class="text-500 text-sm">Name</label>
                        <input id="searchName" name="searchName" type="text" pInputText formControlName="searchName">
                    </div>

                    <div class="flex flex-column gap-2" *ngIf="showSearchAlias">
                        <label for="searchAlias" class="text-500 text-sm">Alias</label>
                        <input id="searchAlias" name="searchAlias" type="text" pInputText formControlName="searchAlias">
                    </div>

                    <div class="flex justify-content-end">
                        <p-button label="Search" type="submit"></p-button>
                    </div>
                </div>
            </form>


        </div>

        <div class="col-10">
<!--            <mvs-widget-->
<!--                    *ngIf="widgetData"-->
<!--                    [widgetData]="widgetData"-->
<!--                    (onObjectSelect)="handleObjectSelect($event)"-->
<!--            ></mvs-widget>-->

          <mvs-widget [widgetData]="widgetData"
                      (onObjectSelect)="handleObjectSelect($event)"
                      *ngIf="widgetData">
          </mvs-widget>

            <mvs-display-message-before-result *ngIf="!widgetData"></mvs-display-message-before-result>
        </div>
    </div>

    <!--    <div class="grid mt-5">-->

    <!--        <div class="col-12">-->
    <!--            <div class="flex gap-5 align-items-center">-->
    <!--                <div class="flex gap-2 align-items-center" *ngIf="showSearchId">-->
    <!--                    <label for="searchId" class="white-space-nowrap">ID</label>-->
    <!--                    <input id="searchId" type="number" pInputText [(ngModel)]="searchId" />-->
    <!--                </div>-->

    <!--                <div class="flex gap-2 align-items-center" *ngIf="showSearchName">-->
    <!--                    <label for="searchName" class="white-space-nowrap">Name</label>-->
    <!--                    <input id="searchName" type="text" pInputText [(ngModel)]="searchName" />-->
    <!--                </div>-->

    <!--                <div class="flex gap-2 align-items-center" *ngIf="showSearchAlias">-->
    <!--                    <label for="searchAlias" class="white-space-nowrap">Name</label>-->
    <!--                    <input id="searchAlias" type="text" pInputText [(ngModel)]="searchAlias" />-->
    <!--                </div>-->

    <!--                <div>-->
    <!--                    <p-button label="Search" (click)="onSearch()"></p-button>-->
    <!--                </div>-->

    <!--            </div>-->

    <!--        </div>-->


    <!--        <div class="col-12 mt-5">-->

    <!--            {{ widgetData |json }}-->

    <!--            <mvs-widget-->
    <!--                    *ngIf="widgetData"-->
    <!--                    [widgetData]="widgetData"-->
    <!--                    (onObjectSelect)="handleObjectSelect($event)"-->
    <!--            ></mvs-widget>-->
    <!--        </div>-->
    <!--    </div>-->

</div>
